import config, { type Locale } from '@packages/config';
import type { AppName } from '../types';
import { getOrderAppRoutePrefixes } from './getOrderAppRoutePrefixes';

export const ORDER_APP_ROUTES = getOrderAppRoutePrefixes(config.order.paths);

const LOCALE_PREFIX_RE = /^\/([a-z]{2}(?:-[A-Z]{2})?)(\/|$)/;

/**
 * Returns true when `href` is a relative path that belongs to the *other* app.
 * External URLs (http/https) are never considered cross-app.
 *
 * @param href   The (optionally localized) href to check — must already have the language prefix applied.
 * @param locale The current locale, e.g. "fr-CH" or "nl-NL".
 * @param appName The current app identifier, e.g. "app-shopping" or "app-order".
 */
export const isCrossAppLink = (href: string, locale: Locale, appName?: AppName): boolean => {
  if (!href.startsWith('/')) return false;
  const withoutLang = href.replace(LOCALE_PREFIX_RE, '/');
  const orderRoutes = getOrderAppRoutePrefixes(config.order.paths, locale);
  const isOrderRoute = (path: string) =>
    orderRoutes.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
  if (appName === 'app-shopping') return isOrderRoute(withoutLang);
  if (appName === 'app-order') return !isOrderRoute(withoutLang);
  return false;
};
